import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Menu from "../../Components/Menu";

const Ongoing = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | در دست اقدام";
        token == null && navigate("/login", { replace: true });
    }, []);

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let status = {
            status: [2, 4],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [showFilter, setShowFilter] = useState(false);
    const [searchText, setSearchText] = useState("");
    const getOrderHandler = (i) => {
        let status = {
            status: [i],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const searchOrder = (e) => {
        let config = {
            url: `${baseUrl}/orders?search=${searchText}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div className="container">
            {showFilter && (
                <div
                    onClick={() => {
                        setShowFilter(false);
                    }}
                    id="bg_gray"
                    className="bg-gray"
                ></div>
            )}
            {showFilter && (
                <div id="filter_modal" className="filter-modal">
                    <div className="filter-modal-head">
                        <svg
                            className="orang-filter"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                opacity="0.4"
                                d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h2>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21 7L11 7"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M3 17L13 17"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                        فیلتر
                    </h2>
                    <button
                        onClick={() => {
                            getOrderHandler(2);
                            setShowFilter(false);
                        }}
                        className="mt-3"
                    >
                        ارسال به انبار
                    </button>
                    <button
                        onClick={() => {
                            getOrderHandler(4);
                            setShowFilter(false);
                        }}
                        className="mt-3"
                    >
                        ارسال به مشتری
                    </button>
                </div>
            )}
            <div className="search-box" id="search_box">
                <div className="pos-rel-search">
                    <input
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        type="text"
                        placeholder="جستجو کنید"
                    />
                    <svg
                        onClick={() => searchOrder()}
                        className="search-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16.5 16.958L21.5 21.958"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <div onClick={() => setShowFilter(true)} className="svg-rec">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className=" c-p"
                    >
                        <path
                            d="M21 7L11 7"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            d="M3 17L13 17"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
            </div>
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : list && list.length !== 0 ? (
                <div className="orders-main">
                    <h1>سفارشات در دست اقدام</h1>
                    {list &&
                        list.length !== 0 &&
                        list.map((item) => {
                            if (
                                item.Status == "ارسال به مشتری" ||
                                item.Status == "ارسال به انبار"
                            ) {
                                return (
                                    <a
                                        className="orders-card"
                                        onClick={(e) => {
                                            navigate(
                                                "/panel/factor/" + item.id
                                            );
                                        }}
                                    >
                                        <img
                                            src={
                                                item.company.avatar
                                                    ? item.company.avatar
                                                    : "/assets/images/logo.svg"
                                            }
                                            alt=""
                                        />
                                        <div>
                                            <span className="name">
                                                {item.company.store_name}
                                            </span>
                                            <span className="fullname">
                                                {item.company.name}{" "}
                                            </span>
                                            <span className="numb">
                                                {item.code}
                                            </span>
                                            <div className="dates">
                                                <button>{item.Status}</button>
                                                <span>{item.Created_at}</span>
                                            </div>
                                        </div>
                                    </a>
                                );
                            }
                        })}
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            opacity="0.4"
                            d="M72.4999 132.917C105.867 132.917 132.917 105.867 132.917 72.5C132.917 39.1328 105.867 12.0833 72.4999 12.0833C39.1327 12.0833 12.0833 39.1328 12.0833 72.5C12.0833 105.867 39.1327 132.917 72.4999 132.917Z"
                            fill="#FF82AE"
                        />
                        <path
                            d="M94.9145 96.2438C94.1291 96.2438 93.3437 96.0625 92.6187 95.5792L73.8895 84.4021C69.2374 81.6229 65.7937 75.5208 65.7937 70.1438V45.3729C65.7937 42.8958 67.8479 40.8417 70.325 40.8417C72.802 40.8417 74.8562 42.8958 74.8562 45.3729V70.1438C74.8562 72.3188 76.6687 75.5208 78.5416 76.6083L97.2708 87.7854C99.4458 89.0542 100.11 91.8333 98.8416 94.0083C97.9354 95.4583 96.4249 96.2438 94.9145 96.2438Z"
                            fill="#FF82AE"
                        />
                    </svg>

                    <p className="emp-text">
                        هیچ شفارش در دست اقدامی ثبت نشده است
                    </p>
                </div>
            )}
            <Menu active="cart" />
        </div>
    );
};

export default Ongoing;
